import { create } from 'zustand'

interface ReplayStore {
    isReplaySupported: boolean
    isReplayEnabled: boolean
    isReplayFinished: boolean
    isLinkCopied: boolean
    replayLink: string
    setIsReplayFinished: (isReplayFinished: boolean) => void
    setIsLinkCopied: (isLinkCopied: boolean) => void
    setIsReplaySupported: (isReplaySupported: boolean) => void
    setIsReplayEnabled: (isReplayEnabled: boolean) => void
    setReplayLink: (replayLink: string) => void
}

export const useReplayStore = create<ReplayStore>((set) => ({
    isReplaySupported: false,
    isReplayFinished: false,
    isLinkCopied: false,
    isReplayEnabled: false,
    replayLink: '',
    setIsReplayFinished: (isReplayFinished) => {
        set({ isReplayFinished })
    },
    setIsLinkCopied: (isLinkCopied) => {
        set({ isLinkCopied })
    },
    setIsReplaySupported: (isReplaySupported) => {
        set({ isReplaySupported })
    },
    setIsReplayEnabled: (isReplayEnabled) => {
        set({ isReplayEnabled })
    },
    setReplayLink: (replayLink) => {
        set({ replayLink })
    },
}))
